module.exports = __webpack_public_path__ + "static/img/m_global_flow_step8@3x.5d205b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_flow_step8@3x.png
// module id = 5J51
// module chunks = 1